import {
  PASSAGE_ZONES,
  WIN_SCORE,
  FIRST_ENTRY_MIN,
  MIN_THREE_DICE,
  THREE_DICE_THRESHOLD,
  PENALTIES,
  BONUSES,
  ZONE_TIERS,
  ZONE_SNAP,
  ZONE_MIN_START,
  ZONE_MAX_END,
  ZONE_MIN_GAP,
  ZONE_MAX_CHAIN_LINKS,
} from '../utils/constants';

// Centralny zestaw reguł gry. Wszystkie wartości liczbowe zebrane w jednym miejscu,
// aby uniknąć "magic numbers" w logice domenowej i UI.
export const gameRules = {
  dice: {
    count: 5,
    faces: 6,
  },
  scoring: {
    winScore: WIN_SCORE,
    firstEntryMin: FIRST_ENTRY_MIN,
    minScoringDice: {
      minCount: 3,
      minPoints: MIN_THREE_DICE,
      thresholdScore: THREE_DICE_THRESHOLD, // poniżej tego progu wymagane ≥3 kości
    },
  },
  tunnels: PASSAGE_ZONES,
  penalties: {
    firstRollBust: PENALTIES.FIRST_ROLL_ZERO,
    overtake: PENALTIES.OVERTAKE,
  },
  bonuses: {
    overtake: BONUSES.OVERTAKE,
  },
  overtake: {
    protectedScore: THREE_DICE_THRESHOLD, // po tym progu brak bonusów/kar za wyprzedzenie
  },
  zones: {
    tiers: ZONE_TIERS,
    snap: ZONE_SNAP,
    minStart: ZONE_MIN_START,
    maxEnd: ZONE_MAX_END,
    minGap: ZONE_MIN_GAP,
    maxChainLinks: ZONE_MAX_CHAIN_LINKS,
  },
} as const;

/**
 * Creates a fresh "all false" kept/captured mask.
 */
export function makeEmptyDiceMask() {
  return Array.from({ length: gameRules.dice.count }, () => false);
}
